import CreatableSelect from "react-select/creatable";

interface OptionType {
  label: string;
  value: string;
}

interface CustomCreatableSelectProps {
  options: OptionType[];
  placeholder: string;
  errors: { brand?: string };
  id: string;
  onChange: (value: string | null) => void;
  value?: string | null;
  label?: string;
}

const CustomCreatableSelect = ({
  options,
  placeholder,
  errors,
  id,
  onChange,
  value,
  label,
}: CustomCreatableSelectProps) => {
  const mappedOptions = options.map((item: any) => ({
    value: item.name,
    label: item.name,
  }));

  const selectedValue = value
    ? mappedOptions.find((opt) => opt.value === value) || { value, label: value }
    : null;

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {label && (
        <label
          htmlFor={id}
          style={{
            position: "absolute",
            top: "-9px",
            left: "10px",
            backgroundColor: "#fff",
            padding: "0 4px",
            fontSize: "0.75rem",
            color: "rgba(0, 0, 0, 0.54)",
            zIndex: 1,
          }}
        >
          {label}
        </label>
      )}
      <CreatableSelect
        isClearable
        inputId={id}
        options={mappedOptions}
        value={selectedValue}
        placeholder={placeholder}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            width: "100%",
            height: "56px",
            minHeight: "56px",
            borderColor: errors.brand ? "red" : "rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            ":hover": {
              borderColor: errors.brand ? "red" : "rgba(0, 0, 0, 0.87)",
            },
          }),
          placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: "16px",
            color: errors.brand ? "#e74c3c" : defaultStyles.color,
          }),
          menu: (base) => ({
            ...base,
            zIndex: 10000,
          }),
        }}
        onChange={(e) => {
          onChange(e ? e.value : null);
        }}
      />
    </div>
  );
};
export default CustomCreatableSelect;
